import React from 'react';
import PropTypes from 'prop-types';

import Fare from '../../records/Fare';
import OrderFare from '../../records/order/Fare';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';

function FareRefundsInfo({ fare, small }) {
    let refundTextMessage = '';

    if (!fare.isRoversRangers()) {
        if (fare.isFlexi()) {
            refundTextMessage = 'booking.fareDetails.refunds.flexiTicket';
        } else if (fare.isSeason()) {
            refundTextMessage = 'booking.fareDetails.refunds.seasonTicket';
        } else if (fare.isAdvance()) {
            refundTextMessage = 'booking.fareDetails.refunds.advanceTicket';
        } else if (fare.isDaySaveOffPeak()) {
            refundTextMessage = 'booking.fareDetails.refunds.daySaveOffPeak';
        } else {
            refundTextMessage = 'booking.fareDetails.refunds.dayTicket';
        }
    }

    return (
        <FormattedHTMLMessage
            message={refundTextMessage}
            className={`margin-top--sm margin-bottom--0 ${small ? 'text-sm' : ''}`}
            tagName="p"
        />
    );
}

FareRefundsInfo.propTypes = {
    fare: PropTypes.oneOfType([PropTypes.instanceOf(Fare), PropTypes.instanceOf(OrderFare)])
        .isRequired,
    small: PropTypes.bool,
};

export default FareRefundsInfo;



// WEBPACK FOOTER //
// ./src/components/fares/FareRefundsInfo.js